// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_lugeB","list":"list_8SAYk","item":"item_Hm9Hh","view-more-wrap":"view-more-wrap_m2F9Y","view-more":"view-more_Q4iMO"};